import React from 'react'
import Reflux from 'reflux-react-16'

import LoginStore from '../../stores/LoginStore.js'

import {Alert, Button, Card, Colors, H3, P} from '../../components/UI/index.js'
import {Input} from '../../components/UI/forms/index.js'
import LoadingPage from './LoadingPage.js'
import t from 'src/helpers/Languages.js'
import {trackTraceLink} from '../../../utils/trackTraceLink.js'

export default class Login extends Reflux.Component {
    constructor(props) {
        super(props)
        this.state = {trackTrace: '', postalCode: '', error: ''}

        this.store = LoginStore
    }

    componentDidMount() {
        const {history} = this.props

        document.title = 'Track & Trace'

        if (history && history.action === 'PUSH' && history.location && history.location.state && history.location.state.notFound) {
            this.setState({error: t('trackTraceNotFound', history.location.state.trackTrace)})
        } else {
            this.setState({error: ''})
        }
    }

    onSubmit(event) {
        event.preventDefault()
        const {trackTrace, postalCode} = this.state

        // A full page load: the server serves the new Track & Trace page when the reseller uses it, that page
        // needs the postal code of the address
        window.location.href = trackTraceLink(encodeURIComponent(trackTrace.trim()), {postalCode})
    }

    render() {
        const {trackTrace, postalCode, error, brandingLoading, branding} = this.state

        if (brandingLoading) {
            return <LoadingPage />
        }

        return (
            <div style={{display: 'flex', flexDirection: 'column', alignItems: 'center', height: '100vh', overflowY: 'auto', background: Colors.backgroundNeutral}}>
                <div style={{flex: 1, display: 'flex', flexDirection: 'column', alignItems: 'center', width: '100%'}}>
                    <form style={{width: '100%', maxWidth: 474, padding: '0 12px'}} onSubmit={this.onSubmit.bind(this)}>
                        <Card shadow='true' style={{display: 'flex', flexDirection: 'column', alignItems: 'center', width: '100%', maxWidth: 450, padding: 24, marginTop: 120, marginLeft: 'auto', marginRight: 'auto'}}>
                            <img style={{maxHeight: 128, maxWidth: 256, marginBottom: 48, objectFit: 'contain'}} src={branding?.mainLogo || '/images/VELOYDLOGO.png'} />

                            <H3 style={{marginBottom: 36}}>Track & Trace</H3>
                            <P style={{maxWidth: 400, marginBottom: 24}}>{t('trackTraceSearchIntro')}</P>

                            <Input
                                style={{width: '100%'}}
                                label={t('trackTraceCode')}
                                value={trackTrace}
                                onChange={(event) => {
                                    this.setState({trackTrace: event.target.value})
                                }}
                            />

                            <Input
                                style={{width: '100%', marginTop: 12}}
                                label={t('postalCode')}
                                value={postalCode}
                                onChange={(event) => {
                                    this.setState({postalCode: event.target.value.toUpperCase()})
                                }}
                            />

                            <Button
                                type='submit'
                                style={{width: '100%', marginTop: 24}}
                                color={branding?.color || Colors.brandColor}
                            >
                                {t('searchButton')}
                            </Button>

                            <div style={{minHeight: 36, marginTop: 12, marginBottom: 24, width: '100%'}}>
                                {error &&
                                    <Alert style={{marginBottom: 6}} variant='danger'>{error}</Alert>
                                }
                            </div>
                        </Card>
                    </form>
                </div>
            </div>
        )
    }
}
